var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ringing 3 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.53753 13.8448C8.53753 9.35496 12.1777 5.71484 16.6661 5.71484C21.156 5.71484 24.7961 9.35496 24.7961 13.8448L24.7975 15.4768C24.7975 16.4419 25.0101 17.3955 25.4215 18.2697L25.9987 19.4957C26.8808 21.3703 25.5123 23.5249 23.4417 23.5249H9.89187C7.82015 23.5249 6.45283 21.3703 7.33496 19.4957L7.91225 18.2697C8.32348 17.3955 8.53623 16.4419 8.53623 15.4768L8.53753 13.8448Z",
    stroke: "#EF6C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.667 4V5.71499",
    stroke: "#EF6C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M6.58105 8.64247C7.18687 7.32315 8.15204 6.08686 9.4026 5.11133",
    stroke: "#EF6C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M26.7512 8.64247C26.1454 7.32315 25.1802 6.08686 23.9297 5.11133",
    stroke: "#EF6C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.4,
    d: "M12.8281 24.1621C12.8281 26.2805 14.5457 27.9993 16.6655 27.9993C18.7839 27.9993 20.5015 26.2805 20.5015 24.1621",
    stroke: "#EF6C00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.3be5d4d7e30d62dfafb494748b1caa3b.svg";
export { ForwardRef as ReactComponent };